import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I have done my schooling from Moradabad, a city in Uttar Pradesh.
Currently I am a Product Engineer at Juspay Technologies, I completed my Undergraduate Course of Bachelor of Technology in
Computer Science and System Engineering w/ Specilization in IoT from SET, Jain University (Bengaluru) in 2023. I am a Full Stack Web and Software Developer and
have done many projects using modern Technologies. I am profecient in programming languages like Python, JavaScript, Haskell, Java, and C. I have developed my projects on frameworks and libraries like NodeJS, ReactJS, Django, etc. with databases such as
Postgres, MongoDB, Redis.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      